import store from '@/store'

import {RawWikiPage} from '@/types/entity/RawWiki'

import {ActiveFormOptions} from '@/components/Ui/ActiveForm/BZCore/ActiveForm'
import {ActiveFieldOptions} from '@/components/Ui/ActiveForm/BZCore/ActiveField'

import StringField from '@/components/Ui/ActiveForm/BZCore/Fields/StringField'
import TextareaField from '@/components/Ui/ActiveForm/BZCore/Fields/TextareaField'
import SelectField from '@/components/Ui/ActiveForm/BZCore/Fields/SelectField'
import TreeSelectField from '@/components/Ui/ActiveForm/BZCore/Fields/TreeSelectField'
import RichTextField from '@/components/Ui/ActiveForm/BZCore/Fields/RichTextField'

// @ts-ignore
import messages from '@/lang/index';

const createForm: ActiveFormOptions = {
  label: messages.wiki.single_page_name,
  submitText: messages.wiki.add_single_node,
  async onSubmit (data: RawWikiPage) {
    console.log('LOG: create wiki page -> data', data)
    let response = await store.dispatch('wiki/createPage', data)
    return response;
  },
  inputs: {
    title: {
      label: messages.labels.title,
      type: StringField,
      required: true,
      options: {}
    },
    parent: {
      label: messages.wiki.node,
      required: true,
      type: TreeSelectField,
      options: {
        async values (scope: any) {
          let list = await store.dispatch('wiki/getNodesTree')
          return list;
        },
        treeProps: {
          label: 'title'
        },
        nodeKey: 'id'
      }
    },
    text: {
      label: messages.wiki.text,
      type: RichTextField,
      required: true,
      options: {}
    }
  },
  steps: [
    {
      map: [
        ['title', 'text', 'parent']
      ]
    }
  ]
}

export default createForm